import { breakpoints } from '@ui/css';
import { Button } from '@ui/kit';
import { useMatchBreakpoint, Chevron } from '@utils/react';
import { useGoToPreviousTaskAction } from '../../../state/actions/task.go-to-prev.js';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { useCurrentTaskEntryId } from '../../../state/hook.entry.js';
import { prevButton } from './_actions.style.js';
import { jsx } from 'react/jsx-runtime';

function PrevButton() {
  const component = useOpgavekompleksetComponent();
  const goToPrevTask = useGoToPreviousTaskAction();
  const currentTaskId = useCurrentTaskEntryId();
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const hasPrevTask = component.data.tasks.findIndex(it => it.id === currentTaskId) > 0;
  return /*#__PURE__*/jsx(Button, {
    className: prevButton,
    theme: "secondary",
    disabled: !hasPrevTask,
    onClick: goToPrevTask,
    icon: {
      position: "before",
      content: /*#__PURE__*/jsx(Chevron, {
        size: 8,
        lineWidth: 1.5,
        inversed: true
      })
    },
    tooltip: isMobile ? {
      placement: "top",
      body: "Forrige",
      ariaType: "label"
    } : undefined,
    children: isMobile ? undefined : "Forrige"
  });
}

export { PrevButton };
//# sourceMappingURL=button.prev.js.map
